export default {
    'workbook': {
        'text': `<div class="content-caption-box">
                <h3 class="content-caption">The Minto Pyramid Principle® Self-Study Course</h3>
            </div>
            <p class="content-text">
                For people who prefer to study from a printed workbook, this course, developed in 1996, is still available for individuals.
                <br> The video portion supplied in CD-ROM or DVD form, plus the book and workbook. This version is priced
                at $1,500 plus postage and handling from New York.
            </p>
            <ul class="list__content-text">
                <li>
                    <p class="content-text">It consists of a 35-minute video overview of the concept plus a copy of the textbook, and an extensive
                        workbook of exercises.
                    </p>
                </li>
                <li>
                    <p class="content-text">
                        You can also for the moment access the highly successful internet version, with video and exercises interlinked. You will
                        receive a free upgrade to the all-new online course when it becomes available later in the year.
                        <br> - This original version is available for 4 months over the Internet at a cost of $1500.
                        <br> - Once your order has entered our system, you will be contacted by minto.sales@comcast.net
                        with Course Log-In Instructions. Upon registration you will also receive the copy of the textbook.
                    </p>
                </li>
            </ul>
            <p class="content-text">Note: The Internet version requires Internet Explorer. It will not function in Firefox or Safari.</p>`,
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/site/workbook/i18n/en.js